/** eslint-disable **/
import Vue from 'vue'
import Router from 'vue-router'
// import home from '../view/home'
// import subPage from '../view/subPage'

import Layout from '@/layout';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Layout,
      redirect: '/home',
      children: [
        {
          path: 'home',
          component: () => import('@/view/home'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'subPage',
          component: () => import('@/view/subPage'),
          name: '子页面',
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'search',
          component: () => import('@/view/search'),
          name: '搜索',
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'news',
          component: () => import('@/view/news'),
          name: '文章详情',
          meta: {
            keepAlive: false
          }
        },
        {
          path: 'publish-piyao',
          component: () => import('@/view/publish-piyao'),
          name: '发布辟谣',
          meta: {
            keepAlive: false
          }
        }

      ]
    },
    {
      path: '/searchNew',
      name: 'searchNew',
      component: () => import('@/view/search-new')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  }
})
